export default __webpack_public_path__ + "static/B0010-eb9d0a4ab661cb9b43c515db06baef90.png";